module.exports = __webpack_public_path__ + "static/media/portfolio1 (20).9b83870b.jpeg";